import type { MultiTableViewDefinition } from '@powerportalspro/core';
import { Calendar } from '@powerportalspro/react-calendar';
import { ACCOUNT_ID } from '../demos/DetailPageRecords';

// Schmeler and Sons, the account the detail page demos feature.
const account = { tableName: 'account', id: ACCOUNT_ID };

const openOnly = (table: string) =>
  `<fetch><entity name="${table}"><filter><condition attribute="statecode" operator="eq" value="0" /></filter></entity></fetch>`;

// Views of several tables: the account's meetings and tasks together, and what is still to do — the
// tasks and calls not yet done.
const views: MultiTableViewDefinition[] = [
  {
    id: '2c7a9e14-5b3d-4f8a-9e61-0d4b7c2a8f11',
    displayName: 'Meetings and tasks',
    tables: [{ table: 'appointment' }, { table: 'task' }],
  },
  {
    id: '2c7a9e14-5b3d-4f8a-9e61-0d4b7c2a8f12',
    displayName: 'Still to do',
    tables: [
      { table: 'task', fetchXml: openOnly('task') },
      { table: 'phonecall', fetchXml: openOnly('phonecall') },
    ],
  },
];

export function CalendarMultiTableSample() {
  return (
    <Calendar
      regarding={account}
      customViewDefinitions={views}
      defaultLayout="month"
      allowFiltering
      allowSavedViews
      savedViewsKey="calendar-multi-table-demo"
      formLocation="right"
      height="640px"
    />
  );
}
